(function () {
  'use strict';

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(null, args); }, wait);
    };
  }

  function init(root) {
    if (!root || root.dataset.muxumCollInit === '1') return;
    root.dataset.muxumCollInit = '1';

    var sectionId = root.closest('[id^="shopify-section-"]');
    sectionId = sectionId ? sectionId.id.replace('shopify-section-', '') : null;

    var main = root.querySelector('.mx-coll__main');
    var filterForm = root.querySelector('#muxum-filter-form');
    var sortForm = root.querySelector('[data-muxum-sort]');
    var sortSelect = sortForm ? sortForm.querySelector('select[name="sort_by"]') : null;

    function buildUrl(formData, extraParams) {
      var params = new URLSearchParams();
      if (formData) {
        formData.forEach(function (value, key) {
          if (value !== '' && value != null) params.append(key, value);
        });
      }
      if (extraParams) {
        Object.keys(extraParams).forEach(function (k) {
          params.set(k, extraParams[k]);
        });
      }
      return window.location.pathname + '?' + params.toString();
    }

    function fetchAndReplace(url) {
      if (!sectionId || !main) {
        window.location.href = url;
        return;
      }
      main.classList.add('is-loading');
      var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + sectionId;
      fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) {
          if (!r.ok) throw new Error('section fetch failed');
          return r.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newMain = doc.querySelector('.mx-coll__main');
          var newFilters = doc.querySelector('.mx-coll__filters');
          if (newMain && main) {
            main.innerHTML = newMain.innerHTML;
          }
          if (newFilters && root.querySelector('.mx-coll__filters')) {
            // Update filter counts/availability without losing scroll
            var currentDetailsState = {};
            root.querySelectorAll('.mx-coll__filter-group').forEach(function (d, i) {
              currentDetailsState[i] = d.open;
            });
            root.querySelector('.mx-coll__filters').innerHTML = newFilters.innerHTML;
            // Re-bind form events on the new filter HTML
            bindFilterEvents();
          }
          // Push state so back button works
          window.history.pushState({ muxumColl: true }, '', url);
          main.classList.remove('is-loading');
          // Re-trigger reveal animations on new cards
          if (window.IntersectionObserver) {
            main.querySelectorAll('.mx-reveal').forEach(function (el) {
              el.classList.add('is-in');
            });
          }
        })
        .catch(function () {
          // Fallback: full page reload
          window.location.href = url;
        });
    }

    function handleFilterChange() {
      var form = root.querySelector('#muxum-filter-form');
      if (!form) return;
      var formData = new FormData(form);
      var extras = {};
      if (sortSelect && sortSelect.value) extras.sort_by = sortSelect.value;
      var url = buildUrl(formData, extras);
      fetchAndReplace(url);
    }

    var debouncedFilter = debounce(handleFilterChange, 250);

    function bindFilterEvents() {
      var form = root.querySelector('#muxum-filter-form');
      if (!form) return;
      form.addEventListener('submit', function (e) { e.preventDefault(); handleFilterChange(); });
      form.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
        input.addEventListener('change', debouncedFilter);
      });
      form.querySelectorAll('input[type="number"]').forEach(function (input) {
        input.addEventListener('change', debouncedFilter);
      });
      var clearBtn = form.parentElement.querySelector('.mx-coll__filter-clear');
      if (clearBtn) {
        clearBtn.addEventListener('click', function (e) {
          e.preventDefault();
          fetchAndReplace(window.location.pathname);
        });
      }
    }

    bindFilterEvents();

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var form = root.querySelector('#muxum-filter-form');
        var formData = form ? new FormData(form) : null;
        var url = buildUrl(formData, { sort_by: sortSelect.value });
        fetchAndReplace(url);
      });
    }

    // Handle browser back/forward
    window.addEventListener('popstate', function (e) {
      if (e.state && e.state.muxumColl) {
        fetchAndReplace(window.location.pathname + window.location.search);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-muxum-coll]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
